import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import { getApiErrorMessage, toApiError } from '../utils';
import { createFormData } from '../helpers/createFormdata';

type UpdateSectorParams = {
	propId: string;
	areaId: string;
	sectorId: string;
	avatar: File;
};

export function useUpdateAvatarSector() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();
	return useMutation({
		mutationFn: async ({ propId, areaId, sectorId, avatar }: UpdateSectorParams) => {
			try {
				const formData = createFormData({ file: avatar });
				return (
					await api.put(
						`/user/prop/${propId}/area/${areaId}/sector/updateAvatar/${sectorId}`,
						formData,
						{ params: { forBinding } }
					)
				).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao atualizar avatar do setor');
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: ['sectors'] });
			queryClient.invalidateQueries({ queryKey: ['propertyId', variables.propId] });
		},
		onError: (error) =>
			console.error(
				'Erro ao atualizar avatar do setor:',
				getApiErrorMessage(error, 'Erro ao atualizar avatar do setor')
			),
	});
}
